<template>
  <div class="details-row">
    <div class="details-row-name">Video Information</div>
    <div class="details-row-content">
      <div class="details-field">
        <div class="details-field-label">Type</div>
        <el-input v-model="name" />
      </div>
      <div class="details-field">
        <div class="details-field-label">Place</div>
        <el-input v-model="place" />
      </div>
      <div class="details-field">
        <div class="details-field-label">Date</div>
        <el-date-picker v-model="date" type="date" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoSettings",
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      date: '',
      name: '',
      place: '',
    }
  },
  methods: {
    getData() {
      return {
        date: this.date,
        name: this.name,
        place: this.place,
      }
    },
    setInitial() {
      this.date = this.details.event_date;
      this.name = this.details.event_name;
      this.place = this.details.event_place;
    },
  },
  mounted() {
    this.setInitial();
  },
}
</script>

<style scoped lang="scss">
.details-row {
  font-weight: 700;
}

.details-row-name {
  font-size: 16px;
  margin-bottom: 15px;
}

.details-row-content {
  display: flex;
  gap: 10px;
}

.details-field {
  flex: 1;
}

.details-field-label {
  padding-bottom: 7px;
  opacity: 0.5;
}
</style>
